import { Box, Grid, Typography } from "@material-ui/core";
import React from "react";
import Footer from "../footer";
import { isString, isEmpty } from "lodash";

import "./style.css";

const WebPageMainRegion = ({ showFooter = true, children, pageHeading }) => {
  return (
    <Box className="app-root-container">
      <Grid
        container
        direction="column"
        alignItems="center"
        className="flex-1 bg-page-container"
      >
        <Grid
          item
          container
          direction="column"
          className="page-content-container flex-1 cus-container"
          alignItems="center"
        >
          <Box className="page-content-inner-container">
            {isString(pageHeading) && !isEmpty(pageHeading) && (
              <Typography className="page-heading text-font-family-primary">
                {pageHeading}
              </Typography>
            )}
            <Grid container direction="column" className="py-16">
              {children}
            </Grid>
          </Box>
        </Grid>
      </Grid>
      {showFooter && <Footer />}
    </Box>
  );
};

export default WebPageMainRegion;
